import React from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import AssignMandateForm from '../../components/mandates/AssignMandateForm';
import MandateOverview from '../../components/mandates/MandateOverview';

function MandateManagement() {
  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <Typography variant="h4" mb={3}>Moyens</Typography>
      
      {/* Formulaire d'attribution toujours visible */}
      <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
        <AssignMandateForm />
      </Paper>

      {/* Table des mandats */}
      <Paper elevation={0} sx={{ width: '100%' }}>
        <MandateOverview />
      </Paper>
    </Box>
  );
}

export default MandateManagement;
